import gql from 'graphql-tag';
import { TAG_FRAGMENT } from '../../fragments/tag.fragment';

export const QUERY_ARTICLES_TABLE = gql`
  query articlesTable {
    articles: publications {
      id
      doi
      year
      authors {
        name
      }
      content {
        title
        language
      }
      tags {
        ...TagData
      }
    }
  }
  ${TAG_FRAGMENT}
`;
